var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('ul',_vm._l((_vm.coursewares),function(courseware){return _c('li',{key:courseware._id},[_c('p',{on:{"click":function($event){return _vm.onClick(courseware)}}},[_vm._v(" "+_vm._s(courseware.material_authentication.title)+" ")])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }